import NotificationSettingsForm from './NotificationSettingsForm';

export default NotificationSettingsForm;
